const en = {
  language: {
    login: "Login",
    inputUserName: "Please enter the user name",
    inputUserPassword: "Please enter the password",
    userNameVaild: "Please enter the correct username",
    passwordVaild: "The password must contain at least three characters",
    panel: "Instrument panel",
    filterSearch: "Filter Search",
    querySearch: "Search",
    inputSearch: "Search: ",
    account: "Account No./Name",
    numbering: "ID",
    accountNumber: "Account No.",
    name: "Name",
    name1: "Name",
    received: "Received",
    toBeReceived: "To Be Received",
    alreadyUsed: "Already Used",
    notUsed: "Unused",
    promoCode: "Promo Code",
    receiveMembership: "Receive Membership",
    claimingMethod: "Claiming Method",
    proactiveAcquisition: "Proactive Acquisition",
    backgroundReward: "Background Reward",
    mail: "Mailbox",
    lastLogin: "Last Logged In",
    isUsed: "Enable",
    action: "Actions",
    asigningRole: "Assigning Roles",
    cancle: "Cancelling",
    determined: "Determined",
    clear: "Clear",
    save: "Save",
    editUser: "Edit User",
    addUser: "Add User",
    editRole: "Edit Role",
    edit: "Edit",
    resourceName: "Resource Name",
    resourcePath: "Resource Path",
    resourceClassification: "Classification",
    editResource: "Edit Resource",
    addResource: "Add Resource",
    addRole: "Add Role",
    password: "Password",
    note: "Remarks",
    userList: "User List",
    changeStatus: "Do you want to change?",
    isDelete: "Are you sure you want to delete this item?",
    isConfirm: "Do you want to confirm?",
    modificationSuccess: "Modification succeeded",
    addSuccess: "Added successfully",
    assignedSuccess: "Assigned successfully",
    cancelModification: "Cancel the modification",
    roleName: "Role Name",
    description: "Description",
    adminCount: "Number of Users",
    asigningMenu: "Assign Menu",
    asigningRes: "Allocating resources",
    dataList: "Data List",
    numberCode: "Number",
    levels: "Levels",
    goodName: "Product Name",
    topicName: "Topic Name",
    goodStatus: "Status",
    selectProduct: "Select Product",
    selectTopic: "Select Topic",
    recommendedOrNot: "Recommended Or Not",
    setSorting: "Set Sorting",
    productSearch: "Product Search",
    topicSearch: "Topic Search",
    articleNo: "Product No.",
    notRecommended: "Not Recommended",
    recommending: "Recommending",
    setRecommending: "Set as recommended",
    cancelRecommending: "Cancel recommendation",
    adName: "AD Name",
    adLocation: "AD Location",
    selectTime: "Select a time",
    addAD: "Add AD",
    category: "Category",
    status: "status",
    adPic: "Advertising Pictures",
    adUrl: "Advertisement link",
    adRemarks: "Ad Remarks",
    time: "Time",
    onOffline: "online/offline",
    online: "online",
    offline: "offline",
    order: "Generate Order",
    clickCount: "Number of clicks",
    pcCarousel: "PC Home Carousel",
    appCarousel: "APP Home Carousel",
    inputAdName: "Enter an ad name",
    inputAdNameLength: "Contains 2 to 140 characters",
    inputAdUrl: "Enter an ad link",
    inputAdStart: "Select a start time",
    inputAdEnd: "Please select the expiration time",
    inputAdPic: "Select an ad image",
    upload: "Upload",
    uploadRule: "Only JPG or PNG files can be uploaded. The file size cannot exceed 10 MB",
    uploadRule2: "You can only upload up to",
    goodsQuality: "Quantity of goods",
    quantityUnit: "Quantity Unit",
    navigationBar: "Navigation Bar",
    isDisplay: "Display or not",
    sorting: "Sorting",
    setting: "Setting",
    viewSubordinates: "View Subordinates",
    transferGoods: "Transfer Goods",
    actions: "Actions",
    modificationSucceeded: "Modification succeeded",
    deleteText: "Are you sure you want to delete the brand?",
    confirm: "Confirm",
    cancel: "Cancel",
    level1: "Level1",
    level2: "Level2",
    categoryName: "Category Name:",
    parentCategory: "Parent Category:",
    selectCategory: "Select a category",
    yes: "Yes",
    no: "No",
    displayInBar: "Display in Navigation Bar",
    categoryIcon: "Category Icon",
    add: 'Add',
    keyWord: "Key words",
    categoryDescription: "Category Description",
    submit: "Submit",
    reset: "Reset",
    enterBrand: "Enter a brand name",
    charLength: "Contains 2 to 140 characters.",
    noParentCategory: "No parent category",
    whetherSubmit: "Whether to submit data",
    submittedSuccessfully: "Submitted successfully",
    validationFailed: "Validation failed",
    keepLeastOne: "Retain at least one",
    addUpThree: "Add up to three",
    filteringAttributes: "Filtering Attributes",
    product: "Products",
    productList: "Product list",
    productCategory: "Product Category",
    addCategory: "Add a Product Category",
    modifyCategory: "Modify a Product Category",
    typeName: "Type name",
    numberAttributes: "Number of Attributes",
    numberParameters: "Number of parameters",
    attributeList: "Attribute List",
    listParameters: "List of parameters",
    enterType: "Enter a type name",
    additionType: "Addition Type",
    editType: "Edit Type",
    attributeName: "Attribute Name",
    productType: "Product Type",
    isOptional: "Whether the attribute is optional or not",
    attributeRecordingMethod: "Attribute Value Recording Method",
    optionalList: "Optional Value List",
    batchOperations: "batch operations",
    selectRecord: "Please select a record",
    selectOperationTypes: "Select a batch operation type",
    isDeleteAttribute: "Do you want to delete the attribute",
    pickList: "Pick from list",
    manualInput: "Manual input",
    choose1: "Single Choice",
    choose2: "Multiple Choice",
    choose3: "The only",
    pleaseSelect: "Please Select",
    categoryFilterStyle: "Category Filter Style",
    ordinary: "Ordinary",
    color: "Color",
    canSearched: "Can be searched",
    search1: "No need to search",
    search2: "Keyword Search",
    search3: "Range Search",
    offeringAssociation: "Offering attribute association",
    availableAttributeList: "List of available attribute values",
    supportAddition: "Support Manual Addition",
    sortingAttributes: "Sorting Attributes",
    enterAttributeName: "Enter an attribute name.",
    offeringAttributeList: "Offering Attribute List",
    addingProductAttribute: "Adding Product Attribute",
    modifyingOfferingSttributes: "Modifying offering attributes",
    pageLose: "Sorry about that, the page it accidentally got lost!",
    checkPageText: "Please check if the URL you entered is correct or not. Click the button below to return to the home page or send an error report",
    returnHome: "Return home",
    searchResult: "Search result",
    productName: "Product Name",
    productNo: "Product No",
    productBrand: "Product brand",
    selectBrand: "Select a brand",
    onStatus: "On-shelf Status",
    all: "All",
    reviewStatus: "Review Status",
    increase: "Add",
    productImage: "Product image",
    brand: "Brand",
    price: "Price",
    goodsNo: "Goods No.",
    labels: "Labels",
    OnShelf: "On-shelf",
    newProducts: "New Products",
    recommends: "Recommends",
    SKUInventory: "SKU Inventory",
    salesVolume: "Sales Volume",
    reviewDetails: "Review Details",
    view: "View",
    edits: "Edits",
    logs: "Logs",
    delete: "Delete",
    editInformation: "Edit Item Details",
    searchSkuNumber: "Search by sku number",
    SKUNumber: "SKU",
    salesPrice: "Sales price",
    merchandiseInventory: "Merchandise Inventory",
    inventoryAlarmValue: "Inventory pre-alarm value",
    productListing: "Product Listing",
    productRemoval: "Product removal",
    setAsRecommended: "Set as recommended",
    cancelRecommendation: "Cancel recommendation",
    setAsNew: "Set as New",
    cancelNewProduct: "Cancel New Product",
    transferCategory: "Transfer to Category",
    moveRecycleBin: "Move to Recycle Bin",
    offShelf: "Off the shelf",
    approved: "Approved",
    notApproved: "Not Approved",
    noSKUInformation: "No SKU information",
    isModify: "Do you want to modify",
    tips: "Tips",
    selectOperationType: "Select an operation type",
    selectProductOperated: "Please select the product to be operated",
    sureOperations: "Are you sure you want to perform the batch operation?",
    sureDelete: "Are you sure you want to delete it?",
    deletedSuccessfully: "Deleted successfully",
    attributeType: "Attribute Type",
    selectAttributeType: "Select an attribute type",
    productSpecification: "Product specification",
    promotionPrice: "Promotion price",
    refreshList: "Refresh the list",
    synchronizePrices: "Synchronize prices",
    synchronizeInventory: "Synchronize Inventory",
    propertyPicture: "Property Picture",
    offeringParameters: "offeringParameters",
    productAlbum: "Product Album",
    productDetails: "Product Details",
    computerDetails: "Computer Details",
    mobileDetails: "Mobile details",
    backPromotion: "Back, fill in the product promotion",
    nextAssociation:  "Next, select the product association",
    attributeCannotEmpty: "The attribute value cannot be empty",
    attributeCannotDuplicate: "The attribute value cannot be duplicated",
    sureSKURefresh: "Refreshing the list will regenerate SKU information. Are you sure you want to refresh?",
    sureSKUSynchronized: "The price of the first SKU will be synchronized to all SKUs. Are you sure you want to continue?",
    sureSKUInventory: "The inventory of the first SKU will be synchronized to all SKUs. Are you sure you want to continue?",
    fillProductInformation: "Fill in the product information",
    fillProductPromotion: "Fill in the product promotion",
    enteringOfferingAttributes: "Entering offering attributes",
    selectProductAssociation: "Select Product Association",
    sureSubmit: "Do you want to submit the product?",
    subtitle: "Subtitle",
    productIntroduction: "Product Introduction",
    enterContent: "Please enter the content",
    productPrice: 'Product price',
    marketPrice: "Market price",
    unitsMeasurement: "Units of measurement",
    productWeight: "Product weight",
    gram: "gram",
    nextPromotion: "Next, fill in the product promotion",
    enterProductName: "Enter a product name",
    enterProductSubtitle: "Enter a product subtitle",
    selectProductSategory: "Select a product category",
    selectProductBrand: "Select a product brand",
    enterProductDescription: "Please enter the product description",
    itemMandatory: "This item is mandatory",
    associatedTopics: "Associated Topics",
    enterTopicName: "Enter a topic name",
    associationSelection: "Association selection",
    enterPreferredName: "Enter a preferred name",
    backFillAttributes: "Back, Fill in offering attributes",
    finishSubmitProduct: "Finish, Submit Product",
    toBeSelected: "To be selected",
    isSelected: "Is Selected",
    rewardingBonusPoints: "Rewarding bonus points",
    rewardGrowthValue: "Reward Growth Value",
    pointPurchaseRestriction: "Bonus point purchase restriction",
    preAnnouncedGoods: "Pre-announced goods",
    offeringRecommendation: "Offering Recommendation",
    serviceAssurance: "Service Assurance",
    hassleFreeReturns: "Hassle-free returns",
    quickRefund: "Quick Refund",
    freePostage: "Free Postage",
    detailPageTitle: "Detail Page Title",
    detailPageDescription: "Detail Page Description",
    commodityKeyword: "Commodity Keyword",
    productRemarks: "Product Remarks",
    selectPreferenceMode: "Select Preference Mode",
    noDiscount: "No discount",
    specialPromotions: "Special Promotions",
    memberPrice: "Member Price",
    tieredPrice: "Tiered price",
    fullyReducedPrice: "Fully Reduced Price",
    startTime: "Start Time",
    selectStartTime: "Select Start Time",
    endTime: "End Time",
    selectEndTime: "Select End Time",
    enterPromotionalPrice: "Enter Promotional Price",
    quantity: "Quantity",
    discounts: "Discounts",
    fulls: "fulls",
    immediateReduction: "immediate reduction",
    backFillInformation: "Back, fill in the product information",
    nextProductAttributes: "Next, fill in the product attributes",
    maximumThree: "A maximum of three records can be added",
    addingProduct: "Adding Product",
    modifyingProduct: "Modifying Product",
    enterSearch: "Enter Search",
    brandName: "Brand Name",
    searchBrandName: "Search Brand Name",
    keywords: "Keywords",
    brandInitials: "Brand Initials",
    brandManufacturer: "Brand Manufacturer",
    related: "Related",
    evaluations: "Evaluations",
    displayBrand: "Display Brand",
    hideBrand: "Hide Brand",
    sureDeleteBrand: "Are you sure you want to delete the brand?",
    brandLOGO: "Brand LOGO",
    brandBigPicture: "Brand Zone Big Picture",
    brandStory: "Brand Story",
    enterBrandLogo: "Enter a brand logo",
    orderMustNumeric: "Order must be numeric",
    brandManagement: "Brand management",
    addBrand: "Add Brand",
    editBrand: "Edit Brand",
    shipmentList: "Shipment List",
    orderNumber: "Order Number",
    consignee: "Consignee",
    mobilePhoneNumber: "Mobile phone number",
    postalCode: "Postal Code",
    shipToAddress: "Ship-To Address",
    shippingMethod: "Shipping Method",
    selectLogisticsCompany: "Select a logistics company",
    logisticsOrderNo: "Logistics Order No",
    SFExpress: "SF Express",
    YuantongExpress: "Yuantong Express",
    ZhongtongExpress: "ZTO Express",
    YundaExpress: "Yunda Express",
    doPerformShipment: "Do you want to perform shipment?",
    shipmentSucceeded: "Shipment succeeded",
    shipmentCancelled: "Shipment Cancelled",
    submittedTime: "Submitted Time",
    nameConsignee: "Name of consignee",
    orderStatus: "Order status",
    orderClassification: "Order Classification",
    orderSource: "Order Source",
    userAccount: "User Account",
    orderAmount: "Order Amount",
    modePayment: "Mode of Payment",
    viewOrders: "Viewing Orders",
    closeOrder: "Close Order",
    orderShipment: "Order Shipment",
    orderTracking: "Order Tracking",
    deleteOrders: "Delete Orders",
    operationRemarks: "Operation Remarks",
    pendingPayment: "Pending Payment",
    pendingShipment: "Pending Shipment",
    shipped: "Shipped",
    completed: "Completed",
    closed: "Closed",
    normalOrder: "Normal Orders",
    seckillOrder: "Place order immediately",
    PCOrders: "PC Orders",
    APPOrder: "APP Orders",
    bulkShipment: "Bulk Shipping",
    Paypal: "Paypal",
    Wechat: "Wechat",
    unpaid: "Unpaid",
    invalidOrder: "Invalid Order",
    selectOrderOperate: "Please select the order you want to operate",
    noShipOrder: "There is no order that can be shipped in the selected orders",
    remarkNotEmpty: "The operation remarks cannot be empty",
    deleteSure: "Are you sure you want to perform the deletion operation?",
    submittingOrder: "Submitting an order",
    paymentOrder: "Payment order",
    platformDelivery: "Platform delivery",
    confirmReceipt: "Confirm receipt",
    completeEvaluation: "Complete the evaluation",
    currentOrderStatus: "Current Order Status",
    modifyConsigneeInformation: "Modify Consignee Information",
    modifyingFeeInformation: "Modifying Fee Information",
    sendingInternalMessage: "Sending an Internal Message",
    remarksOrder: "Remarks Order",
    cancelingOrder: "Canceling an order",
    basicInfo: "Basic Info",
    serialNumber: "Shipment Order Serial Number",
    orderType: "Order Type",
    nonePresent: "None at present",
    automaticConfirmationReceiving: "Automatic confirmation of receiving time",
    preferentialCurrencyOrders: "Preferential currency for orders",
    growthValueOrders: "Growth value of orders",
    eventInfo: "Event Info",
    consigneeInformation: "Consignee information",
    productInformation: "Product Information",
    attributes: "Attributes",
    subtotal: "Subtotal",
    totals: "Totals",
    feeInformation: "Fee information",
    totalCommodities: "Total of commodities",
    freightCharges: "Freight Charges",
    coupons: "Coupons",
    bonusPointDeduction: "Bonus point deduction",
    eventOffers: "Event Offers",
    discountAmount: "Discount Amount",
    totalOrderAmount: "Total Order Amount",
    amountPayable: "Amount payable",
    operatioInfo: "Operation Info",
    operators: "Operators",
    operationTime: "Operation time",
    paymentStatus: "Payment Status",
    shipmentStatus: "Shipment Status",
    regions: "Regions",
    detailedAddress: "Detailed Address",
    titles: "Titles",
    contents: "Contents",
    refunded: "Refunded",
    paid: "Paid",
    unshipped: "Unshipped",
    modifyReceivingInformation: "Do you want to change the Delivery address?",
    modifyFeeInformation: "Do you want to modify the fee information?",
    sentSuccessfully: "Sent successfully",
    sendInternalMessage: "Whether to send an internal message?",
    doClose: "Do you want to close?",
    orderClosedSuccessfully: "The order is closed successfully",
    whetherRemarkOrder: "Whether to remark the order?",
    orderRemarkSucceeded: "Order remark succeeded",
    sureCancelOrder: "Are you sure you want to cancel the order?",
    canceledSuccessfully: "Canceled successfully",
    sureDeletion: "Are you sure you want to perform the deletion operation?",
    seckillOrdersExceed: "Seckill orders exceed",
    minute: "Minute(s)",
    orderAutomaticallyClosed: "Unpaid,The order is automatically closed.",
    normalOrdersOver: "Normal orders over",
    shipmentExceeds: "Shipment Exceeds",
    day: "Day(s)",
    orderAutomaticallyCompleted: "not received. The order is automatically completed.",
    ordersCompletedOver: "Orders completed over",
    transactionAutomaticallyEnded: "The transaction is automatically ended. After-sales services cannot be applied for.",
    fivestarReviews: "Automatic five-star reviews",
    timeCannotEmpty: "The time cannot be empty",
    enterNumericValue: "Please enter a numeric value",
    sureSubmitModification: "Do you want to submit the modification?",
    parameterInvalid: "The submitted parameter is invalid",
    submittedWaitingPayment: "Order submitted and waiting for payment",
    paidSuccessfully: "Order paid successfully",
    scanPendingPayment: "Sub-site scans in Beijing, pending payment",
    ShenzhenWaitingPayment: "Unloading scan at DC Guangdong Shenzhen, waiting for payment",
    scanningShenzhenCompany: "Issue scanning at Guangdong Shenzhen Company",
    deliveredSoon: "Arrive at the destination outlet Guangdong Shenzhen Company, the express will be delivered soon.",
    receivedText: "The order has been received. We look forward to serving you again.",
    orders: "Orders",
    orderList: "Order List",
    orderDetails: "Order Details",
    orderSettings: "Order Settings",
    menuName: "Menu Name",
    frontendPic: "Front-end icon",
    frontendName: "Frontend Name",
    menuLevel: "Menu Level",
    upperMenu: "Upper-level menu",
    selectMenu: "Please select a menu",
    inputMenuName: "Enter a menu name",
    inputFrontendName: "Enter a frontend name",
    inputFrontendPic: "Enter a frontend icon",
    noUpperMenu: "no upper-level menu",
    activityName: "Activity Name",
    settingProduct: "Set Product",
    activityTitle: "Activity Title",
    activityStatus: "Activity Status",
    seckillingTime: "Seckilling time segment list",
    addActivity: "Add Activity",
    activityProgress: "The activity is in progress",
    activityEnded: "The activity has ended",
    activityNotStarted: "Activity has not been started",
    seckillingTimeName: "Seckilling Time Name",
    enabled: "Enabled",
    AddTimeSegment: "Adding a time segment",
    returnedGoods: "Returned goods",
    serviceOrderInformation: "Service order information",
    serviceOrderNo: "Service Order No.",
    applicationStatus: "Application Status",
    timeApplication: "Application Time",
    contactPerson: "Contact Person",
    contactPhone: "Contact phone",
    reasonReturn: "Reason for return",
    problemDescription: "Problem Description",
    voucherPicture: "Voucher Picture",
    confirmRefundAmount: "Confirm the refund amount",
    selectReceivingPoint: "Select a receiving address",
    processingPersonnel: "Processing personnel",
    processingTime: "Processing Time",
    processingRemarks: "Processing Remarks",
    receivingPersonnel: "Receiving personnel",
    receivingTime: "Receiving time",
    receiptRemarks: "Receipt Remarks",
    confirmReturn: "Confirm Return",
    rejectReturn: "Reject Return",
    unprocessed: "Unprocessed",
    returning: "Returning",
    rejected: "Rejected",
    sureOperation: "Do you want to perform this operation?",
    operationSucceeded: "Operation succeeded",
    processingStatus: "Processing Status",
    operatorPerson: "Operators",
    refundAmount: "Refund amount",
    viewDetails: "View details",
    bulkDelete: "Bulk Delete",
    selectApplication: "Please select the application to be operated.",
    reasonType: "Reason Type",
    available: "Available",
    usable: "Usable",
    addTime: "Add Time",
    addReturnReason: "Add Return Reason",
    statusModifiedSuccessfully: "Status modified successfully",
    selectOperation: "Please select the item you want to operate.",
    sureDeleteText: "Are you sure you want to perform the deletion operation?",
    returnRequestProcessing: "Return Request Processing",
    returnReasonSettings: "Return Reason Settings",
    returnReasonDetails: "Return Reason Details",
    remainingQuantity: "Remaining Quantity",
    seckillPrice: "Seckill Price",
    restrictedQuantity: "Restricted purchase quantity",
    seckillNum: "Seckilling quantity",
    editSeckillProduct: "Edit Seckill Product Info",
    addNotice: "Add Notification",
    noticeTitle: "Notification Title",
    noticeIntroduce: "Notification Introduction",
    noticeContent: "Notification content",
    noticePic: "Notification image",
    home: "Home",
    exit: "Exit",
    couponName: "Coupon Name",
    couponType: "Coupon Type",
    availableProduct: "Available Product",
    usageThreshold: "Usage Threshold",
    faceValue: "Face value",
    applicablePlatform: "Applicable Platform",
    validityPeriod: "Validity Period",
    allCoupon: "All-Site Coupon",
    membershipCoupon: "Membership Coupon",
    giftCoupon: "Gift Coupon",
    registrationCoupon: "Registration Coupon",
    notExpired: "Not expired",
    expired: "Expired",
    mobilePlatform: "Mobile Platform",
    pcPlatform: "PC Platform",
    allPlatform: "All Platforms",
    wholeSite: "General for the whole site",
    specifiedCategory: "Specified Category",
    specifiedProduct: "Specified Product",
    totalOrdersToday: "Total Orders Today",
    totalSalesToday: "Total sales today",
    totalSalesYesterday: "Yesterday Sales Amount",
    pendingTransactions: "Pending Transactions",
    pendingOrders: "Pending Orders",
    completedOrders: "Completed Orders",
    ordersToConfirmed: "Orders to be confirmed",
    ordersShip: "Orders to Ship",
    newShortageRegistration: "New Shortage Registration",
    pendingRefundRequests: "Pending Refund Requests",
    shippedOrders: "Shipped Orders",
    pendingReturnOrders: "Pending Return Orders",
    adPositionExpire: "The ad position is about to expire",
    productOverview: "Product Overview",
    offShelf2: "Off the shelf",
    onShelf: "On-shelf",
    tightInventory: "Tight inventory",
    allProducts: "All Products",
    userOverview: "User Overview",
    addedToday: "Added Today",
    addedYesterday: "Added yesterday",
    newTheMonth: "New this month",
    totalNumberMembers: "Total number of members",
    orderStatistics: "Order Statistics",
    totalOrdersMonth: "Total Orders This Month",
    comparedLastMonth: "Compared with Last Month",
    totalOrdersThisWeek: "Total Orders This Week",
    comparedLastWeek: "Compared to last week",
    totalAmountMonth: "Total sales amount of this month",
    totalSalesWeek: "Sales of current week",
    toThe: "to the",
    startDate: "Start Date",
    endDate: "End Date",
    withinLastWeek: "Within the last week",
    withinLastMonth: "Within the last month",
    numberOrders: "Number of Orders",
    videoTutorials: "Video Tutorials",
    totalCirculation: "Total Circulation",
    couponRule1: "Only positive integers are allowed",
    couponRule2: "The face value can only be a number with two decimal places",
    couponRule3: "The value must be a number ranging from 0.01 to 10000, with a maximum of two decimal places",
    cny: "CNY",
    limitPerson: "Limit per person",
    piece: "piece",
    pickupDate: "Pickup Date",
    selectDate: "Select a date",
    to: "to",
    selectCategoryName: "Select a category name",
    categoryName2: "Category Name",
    enterCoupon: "Enter a coupon name"
  },
  menus: {
    首页: "Home",
    仪表盘: "Instrument panel",
    商品: "Product",
    商品列表: "Product List",
    添加商品: "Add Product",
    商品分类: "Product Category",
    商品类型: "Product Classification",
    品牌管理: "Brand Management",
    订单: "Order",
    订单列表: "Order List",
    订单设置: "Order Settings",
    退货申请处理: "Return Request Processing",
    退货原因设置: "Return Reason Setting",
    营销: "Marketing",
    秒杀活动列表: "Seckilling Activity List",
    优惠券列表: "Coupon List",
    品牌推荐: "Brand Recommendation",
    新品推荐: "New Product Recommendation",
    人气推荐: "Popular recommendation",
    专题推荐: "Theme Recommendation",
    广告列表: "Ad List",
    通知列表: "Notification list",
    权限: "Permission",
    用户列表: "User List",
    角色列表: "Role List",
    菜单列表: "Menu List",
    资源列表: "Resource List"
  }
}
export default en;



// WEBPACK FOOTER //
// ./src/locale/en.js